module.exports = __webpack_public_path__ + "static/media/AlsoOpen.c7b4d69d.png";